import React from 'react';
import AccessAlarmsIcon from '@mui/icons-material/AccessAlarms';
function Timer({ minutesDisplay, secondsDisplay }) {
  return (
    <div className="timer-container">
      <div>
        <AccessAlarmsIcon />
      </div>
      <h3 style={{ fontSize: '25px' }}>
        {minutesDisplay}:{secondsDisplay}
      </h3>
    </div>
  );
}

export default Timer;
